// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2v3p6","badges":"styles_badges__1A-4N"};